<template>
    <Head>
        <title>{{ pageData.props.page.title }}</title>
    </Head>
    <body>
        <div class="wrap">
            <!-- GNB -->
            <header class="gnb" aria-label="Global">
                <div class="logo">
                    <a href="/" class="logo__link">
                        <img class="logo__img" src="@/assets/img/logo_white.png" alt="매일국어T" />
                    </a>
                </div>
                <h1 class="gnb__title">{{ pageData.props.page.title }}</h1>
            </header>
            <!-- //GNB -->

            <div class="content">
                <Service v-if="pageData.props.type === 'service'" />
                <Privacy v-else />
            </div>
        </div>
    </body>
</template>

<script setup lang="ts">
    import { Head, usePage } from '@inertiajs/vue3';
    import { PageProps } from '@/teacher/types';
    import Service from '@/app/pages/agreements/Service.vue';
    import Privacy from '@/app/pages/agreements/Privacy.vue';
    import '@/assets/css/brand.scss';

    const pageData = usePage<
        PageProps<{
            type: string;
        }>
    >();
</script>
